import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import {
  Search,
  Shield,
  Laptop,
  Smartphone,
  Calendar,
  DollarSign,
  Edit,
  Eye,
} from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import productimg from "../../product-01-330x440.png";
import productimg1 from "../../product-02-330x440.png";
import productimg2 from "../../product-03-330x440.png";
import { useNavigate } from "react-router-dom";
function AdminProducts() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const navigate = useNavigate();
  const orders = [
    {
      id: "#PR2540",
      img: productimg,
      name: "Product Name",
      date: "07 Oct, 2021",
      cost: "$400",
      total: "200",
      status: "Active",
      method: "Mastercard",
      category: "Hair Regrowth",
      productstatus: "Delivered",
    },
    {
      id: "#PR2541",
      name: "Product Name",
      img: productimg1,
      date: "07 Oct, 2021",
      cost: "$380",
      total: "182",
      status: "Active",
      category: "Skin Care",
      method: "Visa",
      productstatus: "Transit",
    },
    {
      id: "#PR2542",
      img: productimg2,
      name: "Product Name",
      date: "06 Oct, 2021",
      cost: "$384",
      status: "Active",
      method: "Paypal",
      total: "158",
      category: "Mental Health",
      productstatus: "Delivered",
    },
  ];

  const productstatusColors = {
    Active: "success",
    Expired: "warning",
    NotStarted: "destructive",
  };
  return (
    <>
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 mb-1">
              Products List
            </h1>
            <p className="text-gray-600">
              Detailed view of the customer's order including product items,
              shipping information, payment status, and delivery address
            </p>
          </div>
        </div>
        <Card>
          <CardContent className="!p-4">
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex-1 relative">
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
                  size={16}
                />
                <Input
                  placeholder="Search by ID, or product..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="flex gap-3">
                <Select>
                  <SelectTrigger style={{ minWidth: 160 }}>
                    <SelectValue placeholder="All Categories" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Categories</SelectItem>
                    <SelectItem value="Skin">Skin</SelectItem>
                    <SelectItem value="hair">Hair Regrowth</SelectItem>
                    <SelectItem value="Sexual">Sexual Health</SelectItem>
                    <SelectItem value="weight">Weight Loss</SelectItem>
                    <SelectItem value="Mental">Mental Health</SelectItem>
                    {/* Add more categories here */}
                  </SelectContent>
                </Select>
                <Select value={statusFilter} onValueChange={setStatusFilter}>
                  <SelectTrigger className="w-40">
                    <SelectValue placeholder="All Statuses" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Statuses</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="expired">Expired</SelectItem>
                    <SelectItem value="suspended">Suspended</SelectItem>
                  </SelectContent>
                </Select>
                <Button
                  className="bg-xaxathrive-primary hover:bg-blue-700"
                  onClick={() => navigate("/adminproducts/addproduct")}
                >
                  Add Product
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Plans Table */}
        <Card>
          <CardContent className="!p-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="bg-gray-50"></TableHead>

                  <TableHead className="bg-gray-50">Product Name</TableHead>
                  <TableHead className="bg-gray-50">Category</TableHead>
                  <TableHead className="bg-gray-50">Product Cost</TableHead>
                  <TableHead className="bg-gray-50">Available</TableHead>
                  <TableHead className="bg-gray-50">Status</TableHead>
                  <TableHead className="bg-gray-50">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {orders.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell>
                      <input type="checkbox" />
                    </TableCell>

                    <TableCell>
                      <Link
                        to={`/adminproducts/productdetails/${order.id}`}
                        className="text-blue-600 flex items-center"
                      >
                        <div className="custom-bg px-2 py-2">
                          <img
                            src={order.img}
                            alt={order.name}
                            className="w-6 object-cover rounded"
                          />
                        </div>
                        <div>
                          <p className="font-medium text-slate-900">
                            {order.name}
                          </p>
                          <p className="text-sm text-slate-500">
                            ID: {order.id}
                          </p>
                        </div>
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Badge variant="outline" className="text-xs">
                        {order.category}
                      </Badge>
                    </TableCell>

                    <TableCell>{order.cost}</TableCell>
                    <TableCell>{order.total}</TableCell>
                    <TableCell>
                      <Badge
                        variant={
                          productstatusColors[order.status] || "secondary"
                        }
                        className={
                          order.status === "Active"
                            ? "bg-green-100 text-green-600"
                            : order.status === "Expired"
                            ? "bg-red-100 text-red-600"
                            : ""
                        }
                      >
                        {order.status}
                      </Badge>
                    </TableCell>

                    <TableCell>
                      <Button variant="ghost" size="sm">
                        <Edit size={16} />
                      </Button>
                      <Button variant="ghost" size="sm">
                        <Eye size={16} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
export default AdminProducts;
